import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import EmptyState from "@/pages/EmptyState";

/**
 * AdminGuard — outer gate for `/administration/*` routes.
 *
 * Non-admin users NEVER see the admin shell (fixes the leak where
 * Melissa navigated to `/administration/users` and the shell rendered
 * even though the API returned 403). Admin/Super Admin pass through.
 *
 * Behavior:
 *   - Auth still resolving (user === null): render nothing (avoids
 *     a flash of the restricted page).
 *   - Anonymous: <Navigate to="/login" />
 *   - Non-admin authenticated: <Navigate to="/dashboard" replace />
 *     (chose redirect over an in-place empty state so the admin shell
 *     never renders even briefly for non-admins).
 *   - Admin / Super Admin: render children.
 *
 * Canonical resolver: `useAuth().isAdmin`. Do NOT re-implement here.
 */
export default function AdminGuard({ children }) {
  const { user, isAdmin } = useAuth();
  if (user === null) return null;                  // still resolving
  if (user === false) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return children;
}
